const map = {
	"./Daniel-Bateyko-e1737673711732.jpg": 5318,
	"./bo_peng.png": 8432,
	"./boyi_wei.jpg": 5693,
	"./dominik_stammbach.jpg": 3270,
	"./inyoung_cheong.jpg": 6428,
	"./kincaid_macdonald.jpg": 4545,
	"./kylie_zhang.jpg": 7773,
	"./lexin_zhou.png": 2937,
	"./lucia_zheng-2024-25_sigf_1.jpg": 8694,
	"./luxi_he.jpg": 6710,
	"./michel_liao.jpg": 494,
	"./nimra_nadeem.jpg": 1244,
	"./patty_liu.jpg": 8061,
	"./peter_henderson.jpg": 1413,
	"./sijia_liu.jpg": 6963,
	"./xiangyu_qi.jpg": 5852,
	"./zeyu_shen.jpg": 2644,
	"./zirui_cheng.jpg": 6359
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2720;